export const DEFAULT_RANGE_SIZE = 20;
export const SCROLL_BUFFER = 20;
export const SCROLL_THRESHOLD = 50;
export const READY_DELAY = 150;
export const OVERSCAN = 20;
export const SMART_EDGE_PADDING = 40;
export const SMART_VISIBLE_THRESHOLD = 60;
export const SECTION_HEADER_PREFIX = 'section-header-';
